function vzGlossaryOffcanvasInit() {
  const glossaryContainer = jQuery("#wav-glossary-container");
  const glossaryContent = jQuery("#wav-glossary-content");

  if (!glossaryContainer.length || !glossaryContent.length) {
    return;
  }

  initGlossaryLinks();

  glossaryContainer.offcanvas({
    modifiers: "right,overlay",
    triggerButton: "#trigger-element",
  });

  const glossaryOffcanvas = glossaryContainer.data("offcanvas-component");

  jQuery("body").on("click", ".glossary-link", function (event) {
    event.preventDefault();

    if (glossaryContent.data("ajax-loading") == "true") {
      return;
    }
    glossaryContent.data("ajax-loading", "true");

    const data = {
      action: "load_glossary_by_ajax",
      security: vz_ajax.security,
      url: jQuery(this).attr("href"),
    };

    if (data.url === glossaryContent.data("url")) {
      glossaryOffcanvas.open();
      glossaryContent.data("ajax-loading", "false");
    } else {
      jQuery
        .post(vz_ajax.ajaxurl, data, function (response) {
          // load_glossary_by_ajax_callback() wraps its template part in PHP
          // tags, so a miss still answers with the markup's whitespace. The
          // old comparison against "" let that through, which is why an empty
          // panel stayed on screen.
          const markup = String(response || "").trim();

          if (markup !== "") {
            glossaryContent.html(markup);
            glossaryContent.data("url", data.url);
            initGlossaryLinks();
            glossaryOffcanvas.open();
            return;
          }

          // Nothing to show: drop the stale markup and the cached url so the
          // next click asks the server again instead of reopening an empty panel.
          glossaryContent.empty().removeData("url");
          glossaryOffcanvas.close();
        })
        .fail(function (jqXHR) {
          // A failed request used to leave ajax-loading at "true", which killed
          // every further glossary link until the page was reloaded. Say so in
          // the panel and offer the term page, instead of a click that silently
          // does nothing.
          console.error(
            "Glossary request failed:",
            jqXHR.status,
            jqXHR.statusText
          );

          glossaryContent
            .empty()
            .removeData("url")
            .append(
              jQuery("<p>", {
                class: "glossary-error",
                text: "Die Erkl\u00e4rung konnte nicht geladen werden.",
              }),
              jQuery("<p>").append(
                jQuery("<a>", {
                  href: data.url,
                  text: "Zum Glossareintrag",
                })
              )
            );
          glossaryOffcanvas.open();
        })
        .always(function () {
          glossaryContent.data("ajax-loading", "false");
        });
    }
  });
}

/** check for links to explanations and add class */
function initGlossaryLinks() {
  const anchors = Array.from(document.getElementsByTagName("a"));

  // match for path and enforce subpath
  const glossaryPathRe = /\/glossar\/[^/]+/;

  // Links that never leave the page. On a /glossar/<term>/ page their href
  // resolves to that very path, so they would match below and the offcanvas
  // handler would swallow their click - it did for the Borlabs cookie
  // preference and for "back to top".
  const inPageLinkRe = /^#/;

  // Borlabs opens its dialog from its own handler, whatever the link points to.
  const excludedSelector = ".borlabs-cookie-preference";

  anchors.forEach((anchor) => {
    if (inPageLinkRe.test(anchor.getAttribute("href") || "")) {
      return null;
    }

    if (anchor.closest(excludedSelector)) {
      return null;
    }

    const url = new URL(anchor.href, window.location.origin);
    // when url leads to different host abort
    if (url.origin !== window.location.origin) {
      return null;
    }

    if (glossaryPathRe.test(url.pathname)) {
      anchor.classList.add("glossary-link");
    }
  });

  /**
   *
   */
  function initGlossary() {
    var $glossary = jQuery(".archive-grid");
    //var $filter = jQuery('.glossary-filter');
    if (!$glossary.length) {
      return;
    }

    // The pathname check that used to follow relied on a <base href> element.
    // No template renders one, so jQuery("base").attr("href") was undefined and
    // threw here - which aborted initGlossaryLinks() and with it the offcanvas
    // setup on every page that renders .archive-grid. It only computed a value
    // nobody read, so it is gone instead of guarded.
    const glossaryLinks = jQuery(".directlink");

    for (let i = 0; i < glossaryLinks.length; i++) {
      glossaryLinks[i].classList.remove("glossary-link");
    }
  }

  initGlossary();

  if (document.querySelector(".archive-grid[data-accordion]") !== null) {
    if (Foundation.MediaQuery.is("medium down")) {
      jQuery(".archive-grid").foundation(
        "up",
        jQuery(".archive-grid.accordion-content")
      );
    }
  }
}

/*
var Shuffle = window.Shuffle;

var glossaryFilter = function(element) {
  this.letters = Array.from(document.querySelectorAll('.glossary-filter .button'));

  this.shuffle = new Shuffle(element, {
    easing: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)', // easeOutQuart
    //sizer: '.glossary-list',
  });

  this.filters = {
    letters: [],
  };

  this._bindEventListeners();
};
/**
 * Bind event listeners for when the filters change.
 */
/*
glossaryFilter.prototype._bindEventListeners = function(){
  this.onLetterChange = this._handleLetterChange.bind(this);
  this.letters.forEach(function (button) {
    button.addEventListener('click', this.onLetterChange);
  }, this);
};

/**
 * Get the values of each `active` button.
 * @return {Array.<string>}
 */
/*
glossaryFilter.prototype._getCurrentLetterFilters = function () {
  return this.letters.filter(function (button) {
    return button.classList.contains('active');
  }).map(function (button) {
    return button.getAttribute('data-value');
  });
};

/**
 * A Letter button was clicked. Update filters and display.
 * @param {Event} evt Click event object.
 */
/*
glossaryFilter.prototype._handleLetterChange = function (evt) {
  var button = evt.currentTarget;

  // disable following anchor
  evt.preventDefault();

  // Treat these buttons like radio buttons where only 1 can be selected.
  if (button.classList.contains('active')) {
    button.classList.remove('active');
  } else {
    this.letters.forEach(function (btn) {
      btn.classList.remove('active');
    });

    button.classList.add('active');
  }

  this.filters.letters = this._getCurrentLetterFilters();
  this.filter();
};

/**
 * Filter shuffle based on the current state of filters.
 */
/*
glossaryFilter.prototype.filter = function () {
  if (this.hasActiveFilters()) {
    this.shuffle.filter(this.itemPassesFilters.bind(this));
  } else {
    this.shuffle.filter(Shuffle.ALL_ITEMS);
  }
};

/**
 * If any of the arrays in the `filters` property have a length of more than zero,
 * that means there is an active filter.
 * @return {boolean}
 */
/*
glossaryFilter.prototype.hasActiveFilters = function () {
  return Object.keys(this.filters).some(function (key) {
    return this.filters[key].length > 0;
  }, this);
};
/**
 * Determine whether an element passes the current filters.
 * @param {Element} element Element to test.
 * @return {boolean} Whether it satisfies all current filters.
 */
/*
glossaryFilter.prototype.itemPassesFilters = function (element) {
  var letters = this.filters.letters;
  var letterItem = element.getAttribute('data-letter');

  // If there are active color filters and this color is not in that array.
  if (letters.length > 0 && !letters.includes(letterItem)) {
    return false;
  }

  return true;
};


var glossaryOnLoaded = () => {
  window.glossaryFilter = new glossaryFilter(document.querySelector('.archive-grid'));
}

if (document.readyState !== 'loading') {
  glossaryOnLoaded();
} else {
  document.addEventListener('DOMContentLoaded', glossaryOnLoaded);
}
*/

/*
if(document.querySelector('.filter-container.accordion-item')) {
  disableEmptyContainers();
}

function disableEmptyContainers() {
  const emptyLists = document.querySelectorAll('.filter-container.accordion-item');

  emptyLists.forEach(function() {
    this.parentElement.classList.add('disabled');
  })
}

 */
